// Third party
import { useQuery } from '@tanstack/react-query';

// Hooks
import { useAppDispatch } from '../../useAppStore';
import { ProfileController } from '../../../services';

// Components
import { useError } from '../../useError';
import { QUERY_KEYS } from '../../../utils';
import { profileDataActions } from '../../../store';
import { TAxiosError, TGetBiometricDataRes } from '../../../types/responses';

const useGetBiometricDataAPI = () => {
  const dispatch = useAppDispatch();
  const { handleReqError } = useError();

  return useQuery({
    queryKey: [QUERY_KEYS.BIOMETRIC_DATA],
    queryFn: async () => {
      try {
        const rsp = await ProfileController().getBiometricData<TGetBiometricDataRes>();
        dispatch(profileDataActions.setBiometricData(rsp.data));
        return rsp;
      } catch (err) {
        await handleReqError(err as TAxiosError);
      }
    },
  });
};

export { useGetBiometricDataAPI };
